/*eslint-disable*/
import React, { useEffect, useState } from 'react'
import { Input, Form as FormUi, Message, Segment, Icon, Table } from 'semantic-ui-react'
import Axios from 'axios'
import APP_CONSTANTS from '../../../config/constants'
import { Field } from 'formik'
import moment from 'moment';
import { MyCheckBox } from '../../apiInputComponent/myInput'
import { DateData } from '../../apiInputComponent/dateData';

import JobcardCheckboxSelect from '../../apiInputComponent/jobcardCheckboxSelect';
import AddSerialNoModal from './addSerialNoModal';
//Dropdowns
import JobcardSerialNo from '../../apiInputComponent/jobcardSerialNo';
import AddSerialNoInput from './addSerialNoInput';
import { values } from 'lodash'
import { BATTERY_JOBCARD_ACTIVITY } from '../../../utils/constants'

const BatteryEdit = ({ vehicleInDate, cardTypeId, vehicleIdrole, viewMode, ...props }) => {

  const [conditionData, setConditionData] = useState([]);
  const [openNewSerialNoModal, setOpenNewSerialNoModal] = useState(false);
  console.log(props.jbValues,'jbValues');

  useEffect(() => {
    let token = localStorage.getItem('apiToken')
    let userId = localStorage.getItem('userId')
    let customerNo = localStorage.getItem('customerNo')
    let data = JSON.stringify
      ({
        api_token: token,
        customerNo: customerNo,
        jobCardTypeId: cardTypeId,
        vehicleInDate: moment(vehicleInDate).format('DD-MM-YYYY'),
        vehicleId: vehicleIdrole,
        userId: userId,
      })
    Axios.post(`${APP_CONSTANTS.BASE_URL}fleet/jobcard/getJobCardApproverRole`, data, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': token
      }
    }).then((response => {
      if (response.data.status === 1) {
        setConditionData(response.data.data)
        let arr = []
        response.data.data.map((o) => {
          arr.push(o.roleId)
        })
        props.conditionRoleId(arr)
        props.jbConditionId(response.data.data[0])
        props.valueForApproval(vehicleInDate)
      } else {
        setConditionData([])
        props.conditionRoleId([])
      }
    }))
      .catch(error => console.log(error))

  }, [/* props?.vehicleInfoarray, props?.jbValues?.batteryDetails?.serialNo, props?.jbValues?.batteryDetails?.oldSerialNumber */])


  return (
    <>
      <Segment>
        <div className="ui form subform tiny">
          <FormUi.Group inline>
            <FormUi.Field >
              <label className="labelName w3-text-blue">Battery Details</label>
            </FormUi.Field>
          </FormUi.Group>
          {props?.jbValues?.batteryDetails.length > 0 && props?.jbValues?.batteryDetails?.map((obj,i) => { return (<>
          <FormUi.Group inline>
            {props.jbValues.jobcardActivity == BATTERY_JOBCARD_ACTIVITY.REMOVE ?
              <>
                <FormUi.Field width={1}>
                  {/* <Field component={MyCheckBox} /> */}
                  <Field
                    name='batteryDetails.checkboxSelect'
                    component={JobcardCheckboxSelect}
                    setFlag={`batteryDetails.flag`}
                    checked={obj?.checkboxSelect}
                                        /* value={props.jbValues.batteryDetails.checkboxSelect}  */ />

                  {/* <input type="checkbox" class="hidden" readonly=""
                                        onChange={(e) => { props.jbValues.batteryDetails.selectedCheckbox = e.target.checked }} /> */}
                </FormUi.Field>
                <FormUi.Field width={1} />
              </> : null}
            {props.jbValues.jobcardActivity == BATTERY_JOBCARD_ACTIVITY.ADD || props.jbValues.jobcardActivity == BATTERY_JOBCARD_ACTIVITY.REPLACE ?
              null :
              <>
                <FormUi.Field width={4}>
                  <label className="labelName">Serial Number</label>
                </FormUi.Field>
                <FormUi.Field width={3}>
                  <Field name="batteryDetails.oldSerialNumber" readOnly />
                </FormUi.Field>
                <FormUi.Field width={1} />
              </>}

            {props.jbValues.jobcardActivity == BATTERY_JOBCARD_ACTIVITY.REPLACE ?
              <>
                {/* <FormUi.Field width={3}>
                  <label className="labelName">Installation Date</label>
                </FormUi.Field>
                <FormUi.Field width={3}>
                  <DateData
                    name={`batteryDetails[${i}].batteryInstallationDate`}
                    readOnly={props?.viewOnly ? true : false}
                    autoComplete="off"
                    popperClassName="dateTime"
                    dateFormat="dd-MM-yyyy"
                    placeholderText="In Date"
                    setFlag={`batteryDetails.flag`}
                    selected={obj.batteryInstallationDate}
                    customInput={<FormUi.Input autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                  /> */}
                  {/* <Field name="batteryDetails.installationDate" readOnly placeholder="Installation Date" /> */}
                {/* </FormUi.Field> */}
                <Table unstackable size="small">
                    <Table.Header>
                      <Table.Row>
                      <Table.HeaderCell className="labelName p-bold-600">Serial Number443</Table.HeaderCell>
                      <Table.HeaderCell className="labelName p-bold-600">Installation Date</Table.HeaderCell>
                      <Table.HeaderCell className="labelName p-bold-600">New Serial Number</Table.HeaderCell>
                      <Table.HeaderCell className="labelName p-bold-600">New Installation Date</Table.HeaderCell>
                      </Table.Row>
                      </Table.Header>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell>
                          <Field name="batteryDetails.oldSerialNumber" value={obj?.oldSerialNo} readOnly />
                          </Table.Cell>

                          <Table.Cell>
                          <Field name="batteryDetails.installationDate" value={obj?.oldInstallationDate} readOnly placeholder="Installation Date" />
                          </Table.Cell>

                          <Table.Cell>
                          <FormUi.Group inline>
                          <Field
                            name={`batteryDetails[${i}]`}
                            component={JobcardSerialNo}
                            showAddSrno={props?.jbValues?.jobcardActivity == BATTERY_JOBCARD_ACTIVITY.ADD && obj?.oldSerialNumber?.length > 0 || viewMode? false : true}
                            placeholder={obj?.serialNo ? obj.serialNo : "Sr. No."}
                            disabled={props?.jbValues?.jobcardActivity == BATTERY_JOBCARD_ACTIVITY.ADD && obj?.oldSerialNumber?.length > 0 || viewMode ? true : false}
                            typeOfActivity={props.jbValues.jobcardActivity}
                            addNewSerialNoPassed={obj.oldSerialNumber}
                            oldMapIdPassed={obj.oldBatteryMapId}
                            modeCheck="new"
                            setFlag={`batteryDetails[${i}].flag`}
                            TyreId="0"
                            value={obj?.serialNo} />
                            </FormUi.Group>
                          </Table.Cell>

                          <Table.Cell>
                          <DateData
                            name={`batteryDetails[${i}].newInstallationDate`}
                            readOnly={props?.viewOnly || viewMode ? true : false}
                            autoComplete="off"
                            popperClassName="dateTime"
                            dateFormat="dd-MM-yyyy"
                            placeholderText="In Date"
                            setFlag={`batteryDetails[${i}].flag`}
                            selected={obj?.batteryInstallationDate}
                            customInput={<FormUi.Input autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                          />
                          </Table.Cell>
                        </Table.Row>
                      </Table.Body>
                      </Table>
              </>
              :
              <></>}

            {props.jbValues.jobcardActivity == BATTERY_JOBCARD_ACTIVITY.REMOVE || props.jbValues.jobcardActivity == BATTERY_JOBCARD_ACTIVITY.REPLACE ?
              null :
              <>
                {
                  
                  <>
                    <FormUi.Field width={3}>
                      <label className="labelName">New Serial Number</label>
                    </FormUi.Field>
                    <FormUi.Field width={3}>
                      {
                        (props?.jbValues?.jobcardActivity == BATTERY_JOBCARD_ACTIVITY.ADD)
                          ?
                          <>
                          <Field
                            name={`batteryDetails[${i}]`}
                            component={JobcardSerialNo}
                            showAddSrno={props?.jbValues?.jobcardActivity == BATTERY_JOBCARD_ACTIVITY.ADD && obj[i]?.oldSerialNumber?.length > 0 || viewMode ? false : true}
                            placeholder={props?.jbValues?.jobcardActivity == BATTERY_JOBCARD_ACTIVITY.ADD && obj?.serialNo ? obj.serialNo : "Sr. No."}
                            disabled={props?.jbValues?.jobcardActivity == BATTERY_JOBCARD_ACTIVITY.ADD && obj[i]?.oldSerialNumber?.length > 0 || viewMode ? true : false}
                            typeOfActivity={props.jbValues.jobcardActivity}
                            addNewSerialNoPassed={obj[i]?.oldSerialNumber}
                            oldMapIdPassed={obj?.[i]?.oldBatteryMapId}
                            modeCheck="new"
                            setFlag={`batteryDetails[${i}].flag`}
                            TyreId="0"
                            value={obj?.serialNo} />
                            </>
                          :
                          null
                      }

                    </FormUi.Field>
                  </>
                }
              </>}
            {props.jbValues.jobcardActivity != BATTERY_JOBCARD_ACTIVITY.REPLACE ?
              <>
                <FormUi.Field width={1} />
                <FormUi.Field width={4}>
                  <label className="labelName">Installation Date</label>
                </FormUi.Field>
                <FormUi.Field width={3}>
                  <DateData
                    name={`batteryDetails[${i}].batteryInstallationDate`}
                    readOnly={props?.viewOnly || viewMode ? true : false}
                    autoComplete="off"
                    popperClassName="dateTime"
                    dateFormat="dd-MM-yyyy"
                    setFlag={`batteryDetails.flag`}
                    selected={obj[i]?.batteryInstallationDate}
                    placeholderText={obj[i]?.batteryInstallationDate}
                    customInput={<FormUi.Input autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                  />
                </FormUi.Field>
              </> : null}
          </FormUi.Group>
          
            </>)})}

          {conditionData.length > 0 ?
            conditionData.map((object, i) => (
              <>
                <Message size="tiny" info icon>
                  <Message.Content>
                    <p>
                      Approver: <b>{object.roleName} </b>
                      Duration: <b>{object.endValue} Months</b>
                    </p>
                  </Message.Content>
                </Message>
              </>
            ))
            : ''
          }
        </div>
        {/* <AddSerialNoModal setmodalOpen={setOpenNewSerialNoModal} modalOpen={openNewSerialNoModal} /> */}

      </Segment>
    </>
  )

}


export default BatteryEdit